module.exports = __webpack_public_path__ + "static/hiron_rgkr-4afb21532e99efd910bce37ee8c647c8.jpg";